import { useTheme } from "@mui/material";

export default function Basket({ width = 30, height = 30, strokeColor, ...rest }) {
  const theme = useTheme();
  const stroke = strokeColor || theme.palette.rgd.primary;

  return (

    <svg 
        width={width} 
        height={height} 
        viewBox="0 0 30 30" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path 
            d="M25 12.5L23.1431 21.7845C22.914 22.9299 22.7995 23.5026 22.5005 23.931C22.2368 24.3088 21.8738 24.6062 21.4516 24.7907C20.9729 25 20.3889 25 19.2208 25H10.7792C9.61113 25 9.02707 25 8.54836 24.7907C8.12621 24.6062 7.76325 24.3088 7.49955 23.931C7.20051 23.5026 7.08597 22.9299 6.85689 21.7845L5 12.5M25 12.5H22.5M25 12.5H26.25M5 12.5H3.75M5 12.5H7.5M22.5 12.5H7.5M22.5 12.5L18.75 5M7.5 12.5L11.25 5M11.25 16.25V20M15 16.25V20M18.75 16.25V20" 
            stroke={stroke}
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
  )
}